import React, { useState, useMemo, useContext } from 'react';
import axios from 'axios';
import SingleItemDetailTemplate from '../../../Reusable_Components/SingleItemDetailTemplate';
import ConfirmModal from '../../../Reusable_Components/ConfirmModal';
import { useParams, useNavigate } from 'react-router-dom';
import { API_ROUTES, API_DOMAIN, headers } from '../../../Reusable_Components/Config/apiConfig';
import { ToastContext } from '../../../../context/ToastContext';
import useDetailFetch from '../../../../hooks/useDetailFetch';

const SingleSegmentationDetails = () => {
  const { segmentationId } = useParams();
  const navigate = useNavigate();
  const { showToast } = useContext(ToastContext);
  const decodedId = segmentationId ? atob(segmentationId) : segmentationId;
  const id = decodedId.replace(/\D/g, '');
  const [showDelete, setShowDelete] = useState(false);

  const url = id ? `${API_DOMAIN}${API_ROUTES['segmentation']}${id}/` : null;
  const { data: details, loading } = useDetailFetch(url);

  const columns = useMemo(() => {
    if (!details) return null;
    const excluded = ['id', 'updated_at', 'created_at'];
    return Object.keys(details)
      .filter(c => !excluded.includes(c))
      .map(c => ({ label: c.charAt(0).toUpperCase() + c.slice(1), field: c }));
  }, [details]);

  const handleDelete = async () => {
    try {
      await axios.delete(API_DOMAIN + API_ROUTES['segmentation'] + id + '/', { headers });
      showToast('Segmentation deleted successfully', 'success');
      navigate('/reporting/segmentation/list');
    } catch (error) {
      showToast('Error deleting Segmentation', 'error');
      console.error('Error deleting Segmentation:', error);
    }
  };

  return (
    <div>
      <SingleItemDetailTemplate
        details={details}
        columns={columns}
        loading={loading}
        entityName="Segmentation"
        listPath="/reporting/segmentation/list"
        editPath={`/reporting/segmentation/input/${btoa(id)}`}
        onDelete={() => setShowDelete(true)}
      />
      {showDelete && (
        <ConfirmModal
          isOpen={showDelete}
          title="Confirm Delete"
          message="Are you sure you want to delete this segmentation?"
          onConfirm={handleDelete}
          onCancel={() => setShowDelete(false)}
        />
      )}
    </div>
  );
};

export default SingleSegmentationDetails;
